module.exports = __webpack_public_path__ + "static/media/issue.09a45259.svg";